import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from '@angular/router';
import {of} from 'rxjs';
import {LandingPageService} from "src/app/data/services/landing-page.service";

/**
 * Wenn man direkt auf eine Webabo-Unterseite navigiert (z. B. auf /sub-change) und die LandingPages noch nicht da sind,
 * wird man ggf. falsch weitergeleitet wegen {@link ExternalLinkGuard.class}. Als Beispiel kann man SDZ nennen - sie wollen, dass bei der Navigation
 * auf /sub-change auf einen externen Link weitergeleitet wird. Leider passiert es nicht, wenn man die URL mit /sub-change selbs ins URL-Feld des Browsers eintippt.
 * Der Resolver überprüft, ob die LandingPages im localStorage sind, und lädt sie ggf. nach.
 */
export const landingPageResolver: ResolveFn<void> = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const landingPageService = inject(LandingPageService);

  // Der Aufruf von .subscribe() reicht aus, um die Ausführung von .getLandingPages() zu triggern und die Daten im LocalStorage zu speichern.
  landingPageService.getLandingPages().subscribe();
  return of(void 0);
}
